import {useTranslation} from "react-i18next";
import CollaborationVictoryBar from "../CollaborationVictoryBar";
import React, {Fragment, useMemo } from "react";
import {StandardStepFooter, Step, StepBody,  StepHeaderType} from "../../Fundamentals/Stepper/Step";
import {StepperCard} from "../../Card/StepperCard";

export default function CollaborationDiagrams({ collaborations, serviceNames, isLoading }) {
    const { t } = useTranslation();
    const groupedChartResult = (collab) => {
        if (!collab || !collab.collaborations) return {};
        return collab.collaborations.reduce((acc, item) => {
            if (!acc[item.serviceName]) acc[item.serviceName] = [];
            acc[item.serviceName].push({
                x: item.nameOfMonth,
                y: item.count,
                label: item.count,
                accumulated: item.accumulated
            });
            return acc;
        }, {});
    }
    
    const collaborationsByYear = useMemo(() => {
        if (!collaborations) return [];
        const years = Array.from(new Set(collaborations.map(x => x.year))).sort((a, b) => a - b);
        return years.map(year => ({
            year,
            collaborations: collaborations.filter(x => x.year === year)
        }));
    }, [collaborations]);

    return <StepperCard title={t('collaboration.annualoverview')} isStepLoading={isLoading} stepHeaderType={StepHeaderType.HORIZONTAL_TIMELINE}>
            {collaborationsByYear.map((item, i) => {
                const groupedData = groupedChartResult(item);
                return <Step title={item.year} key={item.year}>
                    <StepBody>
                        <VictoryThing item={item} groupedData={groupedData} serviceNames={serviceNames} />
                    </StepBody>
                    <StandardStepFooter />
                </Step>
            })}
        </StepperCard>
}

const VictoryThing = ({item, serviceNames, groupedData}) => {
    return <div className="row">
        {serviceNames.map(serviceName => (
            groupedData[serviceName] && (
                <Fragment key={`victoryBar-${item.year}-${serviceName}`}>
                    <div className="col-lg-6 col-xs-12">
                        <div className="victorybar">
                            <CollaborationVictoryBar
                                key={serviceName}
                                data={groupedData[serviceName]}
                                serviceName={serviceName}
                                year={item.year}
                            />
                        </div>
                    </div>
                </Fragment>
            )
        ))}
    </div>
}

